export enum ConsumerApiRoutes {
  ActivityLog = '/consumers/:id/activity-logs',
  ArchivedVehicles = '/consumers/:id/vehicles/archived',
  Interactions = '/consumers/:id/interactions',
  Consumer = '/consumers',
  Search = '/consumers/search',
  OmniSearch = '/consumers/omni-search',
  SearchAnchors = '/consumers/search-anchors',
  ById = '/consumers/:id',
  Addresses = '/consumers/:id/addresses',
  ConsumerEmails = '/consumers/:id/emails',
  ConsumerPhoneNumbers = '/consumers/:id/phoneNumbers',
  ConsumerQuoteEstimate = '/consumers/:id/quote-estimate',
  PendingLocContracts = '/consumers/:id/contracts-with-pending-loc',
  CancellationAcknowledgementContracts = '/consumers/:id/contracts-with-cancellation-acknowledgement',
  CanceledContracts = '/consumers/:id/contracts-with-canceled-status',
  NonPayContracts = '/consumers/:id/contracts-with-non-pay-status',
  InexactMileageContracts = '/consumers/:id/contracts-with-inexact-mileage',
  EasyPayFinancedContracts = '/consumers/:id/contracts-with-easypay-finance',

  ConsumerVehicleById = '/consumers/:id/vehicles/:id',
  ConsumerVehiclePreviousQuoteOrContract = '/consumers/:id/previous',
  ArchiveVehicleById = '/consumers/:id/vehicles/:id/archive',
  UnarchiveVehicleById = '/consumers/:id/vehicles/:id/unarchive',
  MoveVehicleById = '/consumers/:id/vehicles/:id/move',
  ConsumerVehicleSearch = '/consumervehicles/:id',

  ConsumerHomeById = '/consumers/:id/homes/:id',
  ContractsWithPrrBreakdown = '/consumers/:id/contracts-with-pro-rated-refund',

  ConsumerNotes = '/consumers/:id/notes',
  ConsumerNote = '/consumers/:id/notes/:id',
  ConsumerVehicleNotes = '/consumers/:id/vehicles/:id/notes',
  ConsumerTransactions = '/consumers/:id/vehicles/:id/transactions',
  ConsumerQuoteTransactions = '/consumers/:id/vehicles/:id/quotes/:id/transactions',
  ConsumerHomeQuoteTransactions = '/consumers/:id/homes/:id/quotes/:id/transactions',

  TransferOwnershipContracts = '/consumers/:id/contracts-transfer-ownership',
  ContractsWithRoadsideAssistance = '/consumers/:id/contracts-with-roadside-assistance',
}
